module.exports = __webpack_public_path__ + "img/bh.75a541ea.svg";